import React from 'react';
import { Paper } from '@material-ui/core';
import { withRouter } from 'react-router'; // import the react-router-dom components
import { Link } from 'react-router-dom';
import NavigationConfig from '../../navigation/config';
import ResetPasswordForm from './components/reset_password_form';
import useStyles from './styles';
import clsx from 'clsx';
import LanguageDropdown from '../../components/app_common/language_dropdown';
import TranslatedText from '../../components/atoms/translated_text';
import { Translations } from './configuration';

interface IProps {}

const ForgotPassword: React.FC<IProps> = (props) => {
  // console.log('Render ForgotPassword');
  const classes = useStyles();
  const { token } = (props as any).match.params;
  return (
    <React.Fragment>
      <div className={classes.languageButton}>
        <LanguageDropdown />
      </div>
      <div className={clsx(classes.root)}>
        <Paper elevation={7} className={clsx(classes.cardView)}>
          <ResetPasswordForm token={token} />
          <Link className={classes.link} to={NavigationConfig.loginPage().path}>
            <TranslatedText textMap={Translations.back_to_login} />
          </Link>
        </Paper>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ForgotPassword);
